import React, { Component } from 'react';
//import {Alert} from 'react-bootstrap';
import { Table, Jumbotron, Button } from 'react-bootstrap';
//import {Toast} from 'react-bootstrap';
// ;
import config from '../../../config';
//import funciones from '../../middleware/funciones';
//import { Header } from 'react-bootstrap/lib/Modal';

class Impuestos extends Component {
    constructor(props) {
        const currentCompany = sessionStorage.getItem('company');
        const currentUserType = sessionStorage.getItem('tipo');
        super(props);
        this.state = {
            data: [],
            empresa: currentCompany,
            tipo: currentUserType
        };
    }
    componentDidMount() {
        const datasend = {
            method: 'GET',

            headers: {
                'Content-Type': 'application/json',
                'empresa': this.state.empresa,
                'tipo': this.state.tipo,
            }
        }
        fetch(config.servBackEnd + '/taxes/', datasend).then(response => response.json())
            .then(data => this.setState({ data }));
    }

    render() {
        const dato = (this.state.data) ? this.state.data : [];

        const style = {
            color: "white",
            backgroundColor: "DodgerBlue",
            padding: "10px",
            fontFamily: "Arial"
        };

        return (

            <div className="contenedor">

                <Jumbotron style={style}>
                    <h1>Modulo Impuestos</h1>
                </Jumbotron>
                <Button className="plus" size="sm" href="/impuestos/crear/" variant="outline-primary">Crear Impuesto</Button>
                <Table hover bordered responsive size="sm" className="table">
                    <thead>
                        <tr>
                            <th>EMPRESA</th>
                            <th>DESCRIPCION</th>
                            <th>VALOR</th>
                            <th>CODIGO ERP</th>
                        </tr>
                    </thead>
                    <tbody>
                        {dato.map(function (currentData, index) {
                            return <tr key={index + "d0"}>
                                <td key={index + "d1"}>{currentData.ID_EMPRESA}</td>
                                <td key={index + "d2"}>{currentData.DESCRIPCION_IMPUESTO}</td>
                                <td key={index + "d3"}>{currentData.TASA_PORCENTAJE}</td>
                                <td key={index + "d4"}>{currentData.ERP_CODE_IMP || ''}</td>
                                <td key={index + "d5"}><Button size="sm" href={"/impuestos/crear/?" + currentData.ID_IMPUESTOS} variant="outline-primary">Editar</Button></td>
                            </tr>;
                        })}
                    </tbody>
                </Table>
            </div>
        );
    }
}
export default (Impuestos);


// WEBPACK FOOTER //
// ./src/components/bussines/catalogos/impuestos.jsx